import { Box, Text } from '@chakra-ui/react';
import { Temporal } from 'temporal-polyfill';

const hours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];

interface ITemplateProps {
	hourHeightPx: number;
	highLightTime?: Temporal.PlainTime;
}

/**
 * Background of the calendar. Displaying hours and lines
 */
export default function HourTemplate(props: ITemplateProps) {
	return (
		<Box as="aside" id="time-labels" userSelect="none" willChange="scroll-position" position="relative">
			{hours.map((hour) => {
				const time = Temporal.PlainTime.from({ hour });

				return (
					<Box
						w={12}
						key={hour}
						h={`${props.hourHeightPx}px`}
						display="flex"
						justifyContent="flex-start"
						alignItems="flex-start"
						overflow="visible"
						borderRightWidth={{ base: 0, lg: 0.5 }}
						borderRightColor="ui-element-divider"
					>
						<Text fontSize="13px" variant="body-timestamp" color="text-secondary" position="relative" top={-3} py={0}>
							{time.toLocaleString('en-US', { hour: 'numeric', hour12: true }).replace(' ', '')}
						</Text>
					</Box>
				);
			})}

			{props.highLightTime ? (
				<Text
					color="primary.500"
					fontSize="xs"
					lineHeight="initial"
					position="absolute"
					top={props.hourHeightPx * props.highLightTime.hour + (props.hourHeightPx * props.highLightTime.minute) / 60}
					right={1}
					px={1.5}
					py={1}
				>
					{props.highLightTime.toString({ smallestUnit: 'minute' })}
				</Text>
			) : null}
		</Box>
	);
}
